import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n\n  .ant-btn {\n    color: ",
        ";\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    letter-spacing: -0.14px;\n  }\n\n  img {\n    width: ",
        "px;\n    height: ",
        "px;\n    border-radius: 2px;\n    box-shadow: 2.217px 2.217px 8.87px 0px rgba(28, 31, 46, 0.06);\n    object-fit: contain;\n  }\n\n  .remove-button {\n    &:hover {\n      background-color: transparent;\n      color: ",
        ";\n    }\n\n    svg {\n      width: 18px;\n      height: 18px;\n      margin-right: 4px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  flex-grow: 1;\n\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n\n  .rounded-counter {\n    align-self: flex-start;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex-grow: 1;\n\n  &,\n  dd {\n    color: ",
        ";\n    margin-bottom: 0;\n  }\n\n  dt {\n    color: ",
        ";\n    font-weight: 600;\n\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n\n  &,\n  dd {\n    margin-bottom: 0;\n  }\n\n  &,\n  dt {\n    color: ",
        ";\n  }\n\n  dt {\n    font-weight: 400;\n  }\n\n  .amount {\n    display: flex;\n    justify-content: flex-end;\n    flex-grow: 1;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "@/components/common/Image";
import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { deleteBooksCart, putBooksCart } from "src/api/booksCart";
import useBooksOrderStore from "src/store/booksOrder";
import styled from "styled-components";
import { useBooks } from ".";
import NoPadButton from "../../common/Button/NoPadButton";
import RoundedCounter from "../../common/RoundedCounter";
import Icon from "../../icon/Icon";
import { Delete1_5 } from "../../icon/IconList";
import { OrderCardContainer } from "../../Package/OrderComponents/PaymentCard";
const thumbDimensions = {
    width: 71,
    height: 96
};
export const HorizontalStack = styled.div.withConfig({
    componentId: "sc-8fbcaca7-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_500, thumbDimensions.width, thumbDimensions.height, (props)=>props.theme.new.colors.sol_red_400);
export const Stack = styled.div.withConfig({
    componentId: "sc-8fbcaca7-1"
})(_templateObject1());
export const TitleAndAround = styled.dl.withConfig({
    componentId: "sc-8fbcaca7-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_900);
export const Total = styled.dl.withConfig({
    componentId: "sc-8fbcaca7-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_gray_500);
const BooksOrderProductItem = (param)=>{
    let { id , product , quantity , subtotal  } = param;
    const { setItems  } = useBooksOrderStore((param)=>{
        let { setItems  } = param;
        return {
            setItems
        };
    });
    const { isBooks  } = useBooks();
    const deleteBooksOrderMutation = useMutation(deleteBooksCart);
    const putBooksOrderMutation = useMutation(putBooksCart);
    const handleRemove = useCallback((cartItemId)=>async ()=>{
            const result = await deleteBooksOrderMutation.mutateAsync({
                lineItemId: cartItemId
            });
            setItems(result.lineItems, isBooks);
        }, [
        deleteBooksOrderMutation,
        setItems,
        isBooks
    ]);
    const handleChangeCounter = useCallback((cartItemId)=>async (newQuantity)=>{
            const result = await putBooksOrderMutation.mutateAsync({
                lineItemId: cartItemId,
                quantity: newQuantity
            });
            setItems(result.lineItems, isBooks);
        }, [
        putBooksOrderMutation,
        setItems,
        isBooks
    ]);
    return /*#__PURE__*/ _jsx(OrderCardContainer, {
        children: /*#__PURE__*/ _jsxs(Stack, {
            children: [
                /*#__PURE__*/ _jsxs(HorizontalStack, {
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            alt: "book-img",
                            width: thumbDimensions.width,
                            height: thumbDimensions.height,
                            src: product.thumbImg
                        }),
                        /*#__PURE__*/ _jsxs(Stack, {
                            children: [
                                /*#__PURE__*/ _jsxs(HorizontalStack, {
                                    children: [
                                        /*#__PURE__*/ _jsxs(TitleAndAround, {
                                            children: [
                                                /*#__PURE__*/ _jsx("dt", {
                                                    children: product.title
                                                }),
                                                /*#__PURE__*/ _jsx("dd", {
                                                    children: product.author
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(NoPadButton, {
                                            type: "text",
                                            className: "remove-button",
                                            onClick: handleRemove(id),
                                            children: [
                                                /*#__PURE__*/ _jsx(Icon, {
                                                    icon: Delete1_5
                                                }),
                                                "삭제"
                                            ]
                                        })
                                    ]
                                }),
                                isBooks && /*#__PURE__*/ _jsx(RoundedCounter, {
                                    value: quantity,
                                    max: 99,
                                    onChange: handleChangeCounter(id)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Total, {
                    children: [
                        /*#__PURE__*/ _jsx("dt", {
                            children: isBooks ? "합계 금액" : "판매가"
                        }),
                        /*#__PURE__*/ _jsxs("dd", {
                            className: "amount",
                            children: [
                                subtotal.toLocaleString(),
                                "원"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
export default BooksOrderProductItem;
